<template>
  <div class="container">
    <div class="result">
      <h2>报名查询</h2>
      <p class="phone">查询条件</p>
      <p class="listTitle">请填写报名时填报的手机号码</p>
      <div class="inputBox">
        <input v-model="phone" type="tel">
      </div>
      <div class="btn">
        <van-button color="#7A726C" text="查询" @click="onQuery" />
      </div>
      <div class="tip">
        <span>*注意：如果三次未签到，您将无法报名本年度其他活动！</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'queryResule',
  data: () => ({
    phone: ''
  }),
  methods: {
    onQuery () {
      console.log(this.$route.query)
      const rule = /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|4|5|6|7|8|9])\d{8}$/
      if (rule.test(this.phone)) {
        this.$router.push({
          path: '/culturalRelic/myResule',
          query: {
            phone: this.phone,
            activityId: this.$route.query.id
          }
        })
      } else {
        this.$toast.fail('请正确输入手机号')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background: #605C3D url(../../../assets/bg-bj@2x.png) no-repeat top center / 100%;
  overflow: hidden;

  .result {
    width: 300px;
    //height: 405px;
    background: #EFDFCB;
    border-radius: 8px;
    margin: /*300px*/
      30vh auto 100px;
    overflow: hidden;
    position: relative;

    h2 {
      font-size: 17px;
      font-weight: 400;
      color: #F3E6DD;
      text-align: center;
      margin: 0;
      padding: 10px;
      background-color: #CDC0AA;
      margin-bottom: 10px;
    }

    p {
      color: #F3E6DD;
      font-size: 14px;
      font-weight: 500;
      margin: 0 17px 5px;
    }

    .phone {
      padding-bottom: 11px;
      border-bottom: 1px solid #F3E6DD;
      margin-bottom: 16px;
      color: #7A726C;
      a {
        color: #316FEE;
      }
    }

    .listTitle {
      margin-bottom: 12px;
      font-size: 13px;
      font-weight: 400;
      margin-top: 40px;
      color: rgba(72, 83, 73, 1);
    }
    .inputBox {
      padding: 0 17px;
      margin-bottom: 73px;
      font-size: 13px;
    }
    input {
      width: 99%;
      height: 25px;
      background: #E7D8BF;
      border: 0px solid #333333;
      border-radius: 3px;
    }
    .tip {
      font-size: 13px;
      font-weight: 400;
      color: #7A726C;
      margin: 0 22px;
      text-align: left;
      line-height: 1.5;
      span {
        display: block;
        margin: 10px 0;
      }
    }
    .btn {
      width: 100%;
      text-align: center;
      margin-bottom: 38px;
      margin-top: 20px;
      .van-button {
        min-width: 200px;
        height: 40px;
        border-radius: 7px;
      }
    }
  }
}
</style>
